// src/pages/submenu.jsx
"use client"

import { Link } from "react-router-dom"
import BackToMenu from "../components/BackToMenu.jsx"
import { FileText, Calendar, Users } from "lucide-react"

export default function SolicitudAdquisicionesMenu() {
  const styles = {
    page: {
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      background: "#f7f8fa",
      padding: 24,
    },
    header: {
      width: "100%",
      maxWidth: 1100,
      display: "grid",
      gridTemplateColumns: "1fr auto 1fr",
      alignItems: "center",
      marginBottom: 16,
    },
    title: {
      justifySelf: "center",
      fontSize: 24,
      fontWeight: 700,
      color: "#1f2937",
    },
    grid: {
      width: "100%",
      maxWidth: 1100,
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
      gap: 16,
    },
    card: {
      display: "block",
      textDecoration: "none",
      color: "inherit",
      borderRadius: 16,
      background: "white",
      border: "1px solid #e5e7eb",
      padding: 20,
      boxShadow: "0 6px 18px rgba(0,0,0,0.06)",
      transition: "transform 120ms ease, box-shadow 120ms ease",
    },
    cardHover: {
      transform: "translateY(-2px)",
      boxShadow: "0 12px 24px rgba(0,0,0,0.08)",
    },
    cardHeader: { display: "flex", alignItems: "center", gap: 12 },
    iconWrap: {
      display: "grid",
      placeItems: "center",
      width: 44,
      height: 44,
      borderRadius: 12,
      background: "#f3f4f6",
    },
    cardTitle: { fontSize: 18, fontWeight: 600, color: "#111827", margin: 0 },
    cardDesc: { fontSize: 14, color: "#6b7280", margin: "6px 0 0 0" },
  }

  const withHover = (style) => {
    const base = { ...style }
    return {
      style: base,
      onMouseEnter: (e) => Object.assign(e.currentTarget.style, styles.cardHover),
      onMouseLeave: (e) => Object.assign(e.currentTarget.style, base),
    }
  }

  return (
    <div style={styles.page}>
      <div style={styles.header}>
        <div>
          <BackToMenu label="Volver al menú" />
        </div>

        <h1 style={styles.title}>Solicitud de Adquisiciones</h1>

        <div />
      </div>

      <div style={styles.grid}>
        {/* OPS (apunta al procedimiento que sí existe hoy) */}
        <Link
          to="/solicitud-adquisiciones/solicitudes"
          {...withHover(styles.card)}
          aria-label="Ir a OPS"
        >
          <div style={styles.cardHeader}>
            <div style={styles.iconWrap}>
              <FileText size={20} />
            </div>
            <div>
              <h2 style={styles.cardTitle}>OPS</h2>
              <p style={styles.cardDesc}>
                Registrar solicitudes OPS a partir de necesidades aprobadas.
              </p>
            </div>
          </div>
        </Link>

        {/* Vigencias Futuras (ruta aún no creada en el router) */}
        <Link
          to="/solicitud-adquisiciones/vigencias-futuras"
          {...withHover(styles.card)}
          aria-label="Ir a Vigencias Futuras"
        >
          <div style={styles.cardHeader}>
            <div style={styles.iconWrap}>
              <Calendar size={20} />
            </div>
            <div>
              <h2 style={styles.cardTitle}>Vigencias Futuras</h2>
              <p style={styles.cardDesc}>Gestión de solicitudes con vigencias futuras.</p>
            </div>
          </div>
        </Link>

        {/* Convenios (ruta aún no creada en el router) */}
        <Link
          to="/solicitud-adquisiciones/convenios"
          {...withHover(styles.card)}
          aria-label="Ir a Convenios"
        >
          <div style={styles.cardHeader}>
            <div style={styles.iconWrap}>
              <Users size={20} />
            </div>
            <div>
              <h2 style={styles.cardTitle}>Convenios</h2>
              <p style={styles.cardDesc}>Trámite y seguimiento de convenios interadministrativos.</p>
            </div>
          </div>
        </Link>
      </div>
    </div>
  )
}
